import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import usePersonaStore from "../../Store/PersonaStore";
import useAuthStore from "../../Store/AuthStore";
import useAppStore from "../../Store/SearchStore";
import { Button, ButtonGroup } from "../ui/Button/index";
import { useTranslation } from "react-i18next";

export default function CreatePersona({ forceShow = false, hideLaterButton = false }) {
  const { t } = useTranslation();
  const { personaName, handleLaterClick, openPersonaForm } = usePersonaStore();
  const { isAuthenticated } = useAuthStore();
  const { isSearching } = useAppStore();
  const history = useHistory();
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    // Show component immediately when personaName is available
    if (personaName || forceShow) {
      setShowComponent(true);
    }
  }, [personaName, forceShow]);

  const handleLater = () => {
    // Only allow later click if not forced OR if it's the specific case of unauth persona generation
    if (!forceShow || (forceShow && !isAuthenticated)) {
      handleLaterClick();
    }
  };

  const handleCreatePersona = () => {
    // Open the persona form
    openPersonaForm();
  };

  const handleLoginClick = () => {
    history.push("/login");
  };

  // Don't show anything if no persona name and not forced
  if (!showComponent && !isSearching) {
    return null;
  }

  // Show "Generating your persona" when search is in progress
  if (isSearching) {
    return (
      <div className="flex flex-col items-center gap-[26px] w-full max-w-[425px] px-[13px] py-7 rounded-[20px] bg-grey-500 shadow-[0px_16px_32px_-8px_rgba(12,12,13,0.4)]">
        <div className="flex p-2.5 justify-center items-center w-full">
          <h1 className="flex-1 font-inter font-bold text-2xl leading-[120%] tracking-[-0.48px] text-center">
            <span className="text-black">{t("persona.generatingPersona")}</span>
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-[26px] w-full max-w-[425px] px-[13px] py-7 rounded-[20px] bg-grey-500 shadow-[0px_16px_32px_-8px_rgba(12,12,13,0.4)]">
      <div className="flex p-2.5 justify-center items-center w-full">
        <h1 className="flex-1 font-inter font-bold text-2xl leading-[120%] tracking-[-0.48px]">
          {isAuthenticated ? (
            <>
              <span className="text-black">{t("persona.createPersonaFor")} </span>
              <span className="text-red-500">
                {personaName || t("persona.specialSomeone")}?
              </span>
            </>
          ) : (
            <>
              <span className="text-black">{t("persona.createPersonaFor")} </span>
              <span className="text-red-500">{personaName || t("persona.specialSomeone")} </span>
              <span className="text-black">{t("persona.toViewProducts")}</span>
            </>
          )}
        </h1>
      </div>

      <ButtonGroup spacing="lg">
        {/* Only show "Later" button if user is authenticated OR for unauth users when not forced to hide */}
        {((!forceShow && isAuthenticated) || (!isAuthenticated && !hideLaterButton)) && (
          <Button
            variant="secondary"
            rounded="full"
            size="sm"
            onClick={handleLater}
            className='w-40'
          >
            {t("persona.later")}
          </Button>
        )}

        <Button
          variant="primary"
          rounded="full"
          size="sm"
          onClick={handleCreatePersona}
          className="w-40"
        >
          {t("persona.createPersona")}
        </Button>
      </ButtonGroup>
    </div>
  );
}